module.exports = __webpack_public_path__ + "static/media/Screenshot_5-thumb.679f4c77.png";